import { routerMiddleware } from 'connected-react-router'
import keyMirror from 'pkeymirror'
import { apiMiddleware } from 'redux-api-middleware'
import callAPI from 'utils/callAPI'

// ------------------------------------
// Constants
// ------------------------------------
export const PAYLINK = keyMirror(
  {
    INIT_REQUEST: null,
    INIT_SUCCESS: null,
    SUBMIT_REQUEST: null,
    SUBMIT_SUCCESS: null,
  },
  'PAYLINK'
)

// ------------------------------------
// Actions
// ------------------------------------
export function init(linkId, callback) {
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch,
        method: 'POST',
        body: { linkId },
        endpoint: 'cgs/customerFrontend/paylink/query',
        requestAction: PAYLINK.INIT_REQUEST,
        successAction: PAYLINK.INIT_SUCCESS,
        success(result) {
          console.log('object')
          callback && callback(null, result)
        },
      })
    )
  }
}

export function submit(data, callback) {
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch,
        method: 'POST',
        body: data,
        endpoint: 'cgs/customerFrontend/paylink/confirm',
        requestAction: PAYLINK.SUBMIT_REQUEST,
        successAction: PAYLINK.SUBMIT_SUCCESS,
        success(result) {
          if (result.token) {
            location.href = result.token
          }
          callback && callback(null, result)
        },
        error() {
          callback && callback(new Error('error'))
          dispatch({ type: PAYLINK.SUBMIT_SUCCESS, payload: null })
        },
      })
    )
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [PAYLINK.INIT_REQUEST]: (state, action) =>
    Object.assign({}, state, action.payload),
  [PAYLINK.INIT_SUCCESS]: (state, action) =>
    Object.assign({}, state, action.payload),
  [PAYLINK.SUBMIT_REQUEST]: (state, action) =>
    Object.assign({}, state, { confirmStatus: { isFetching: false } }),
  [PAYLINK.SUBMIT_SUCCESS]: (state, action) =>
    Object.assign({}, state, { confirmStatus: { isFetching: true } }),
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {}
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'paylink',
    reducerMap: {
      paylinkState: reducer,
    },
    // middlewares when this module needed
    middlewares: [apiMiddleware, routerMiddleware(history)],
    // Actions to fire when this module is added/removed
    // initialActions: [],
    // finalActions: []
  }
}
